/* tslint:disable */
/* eslint-disable */
/**
 * external-information-requests
 * Medicaid Pending document requests to family members, with the staff workspace and the family portal
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PortalSession } from './PortalSession';
import {
    PortalSessionFromJSON,
    PortalSessionFromJSONTyped,
    PortalSessionToJSON,
    PortalSessionToJSONTyped,
} from './PortalSession';

/**
 * 
 * @export
 * @interface PortalSessionResponse
 */
export interface PortalSessionResponse {
    /**
     * 
     */
    data: PortalSession;
}

/**
 * Check if a given object implements the PortalSessionResponse interface.
 */
export function instanceOfPortalSessionResponse(value: object): value is PortalSessionResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function PortalSessionResponseFromJSON(json: any): PortalSessionResponse {
    return PortalSessionResponseFromJSONTyped(json, false);
}

export function PortalSessionResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PortalSessionResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': PortalSessionFromJSON(json['data']),
    };
}

export function PortalSessionResponseToJSON(json: any): PortalSessionResponse {
    return PortalSessionResponseToJSONTyped(json, false);
}

export function PortalSessionResponseToJSONTyped(value?: PortalSessionResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': PortalSessionToJSON(value['data']),
    };
}

